import { type CaseTypeRepository, type WorkspaceRepository } from '@telespot/domain';

export interface WorkspaceEncryptionState {
  encrypted: boolean;
  nameEncrypted: boolean;
}

export interface IGetWorkspaceEncryptionStateQuery {
  execute(workspaceId: string): Promise<WorkspaceEncryptionState>;
}

export class GetWorkspaceEncryptionStateQuery implements IGetWorkspaceEncryptionStateQuery {
  constructor(
    private readonly workspaceRepository: WorkspaceRepository,
    private readonly caseTypeRepository: CaseTypeRepository
  ) {}

  async execute(workspaceId: string): Promise<WorkspaceEncryptionState> {
    try {
      const workspace = await this.workspaceRepository.getById(workspaceId);
      if (!workspace) return { encrypted: false, nameEncrypted: false };
      const caseType = await this.caseTypeRepository.getById(workspace.caseTypeId);
      if (!caseType) return { encrypted: false, nameEncrypted: false };
      const encrypted = caseType.fields.some((f) => f.encrypted);
      const nameEncrypted = caseType.fields.some((f) => f.name === 'case_identifier' && f.encrypted);
      return { encrypted, nameEncrypted };
    } catch {
      return { encrypted: false, nameEncrypted: false };
    }
  }
}
